var modules_436816d0 = {"container":"_thtd88","rotate":"_1egw2jv","svg":"_9mffe2","loading":"_1v0isrp","circle":"_1v96q6y","circle-1":"_t1h4fo","color-blue":"_1e4q7q2","color-green":"_1p55hou","circle-2":"_1ppg3xf","loading-circle":"_1ix5zke","size-16":"_16f9nd0","size-20":"_21gbs0","size-24":"_pvjukt","size-28":"_14anfa0"};
import "../../../assets/CqQbFnQF.css";

export { modules_436816d0 as default };
//# sourceMappingURL=Spinner.module.less.js.map
